export default {

  namespaced: true,

  state: () => ({

    activity: {},
    activities: {},

    description: [
      {
        action: 'personInserted',
        description: 'Nova pessoa Cadastrada',

      },
      {
        action: 'personUpdated',
        description: 'Cadastro de pessoa Atualizado'
      },

      {
        action: 'orderInsertedAsDraft',
        description: 'Venda salva como Rascunho'
      },
      {
        action: 'orderUpdatedAsDraft',
        description: 'Venda atualizada para Rascunho '
      },
      {
        action: 'orderInsertedAsProposal',
        description: 'Venda salva como Orçamento'
      },
      {
        action: 'orderUpdatedAsProposal',
        description: 'Venda atualizada para Orçamento '
      },
      {
        action: 'orderInsertedAsConfirmed',
        description: 'Venda  Confirmada '
      },
      {
        action: 'orderUpdatedAsConfirmed',
        description: 'Venda atualizada e Confirmada'
      },
      {
        action: 'orderCanceled',
        description: 'Venda Cancelada'
      },
      {
        action: 'storeProduct',
        description: 'Novo produto Cadastrado'
      },
      {
        action: 'updateProduct',
        description: 'Produto Atualizado'
      },
      {
        action: 'storeCompany',
        description: 'Nova empresa Cadastrada'
      },
      {
        action: 'updateCompany',
        description: 'Dados da empresa Atualizada'
      },
      {
        action: 'storeAccount',
        description: 'Novo Caixa/Conta diário Cadastrado',
      },
      {
        action: 'updateAccount',
        description: ' Caixa/Conta Atualizado',
      },
      {
        action: 'cancelAccountTransaction',
        description: 'Transação de  Caixa/Conta Cancelada',
      },
      {
        action: 'storeCustomTransaction',
        description: 'Nova transação Personalizada '
      },
      {
        action: 'storeOrderTransaction',
        description: 'Nova transação de Venda'
      },
      {
        action: 'storeBillReceivementTransaction',
        description: 'Nova transação de Contas a Receber'
      },
      {
        action: 'storeTransferTransaction',
        description: 'Transferência Realizada'
      },
      {
        action: 'billStore',
        description: 'Nova conta Adicionada'
      },
      {
        action: 'billCancel',
        description: 'Conta Cancelada '
      },
      {
        action: 'userStore',
        description: 'Novo usuário Cadastrado'
      },
      {
        action: 'userUpdate',
        description: 'Usuário Atualizado'
      },
      {
        action: 'StockUpdate',
        description: 'Atualização de estoque'
      },
      {
        action: 'stockUpdateProductCompany',
        description: 'Atualização de estoque e produtos da Empresa'
      },
      {
        action: 'stockUpdateCostProductVariant',
        description: 'Atualização no preço de custo do produto'
      },
    ]
  }),

  mutations: {
    setActivities(state, data) {
      state.activities = data
    },
    setActivity(state, data) {
      state.activity = data
    },
  },

  actions: {
    async getActivities({ dispatch, commit }, params) {
      const data = await axios.get("/erp/activity/useractivities", { params: params })
      commit('setActivities', data.data)
    },

    async getActivity({ dispatch, commit }, { params, id }) {

      let url = '/erp/activity/useractivities/' + id

      await axios.get(url, { params: params })
        .then(response => {

          let dataActivity = {
            description: null,
            document: null,
            name: null,
            id: null,
          }

          if (params.foreign_table == "bill") {
            dataActivity.name = response.data.name
            dataActivity.document = response.data.document
            dataActivity.description = response.data.history
          }

          if (params.foreign_table == "account_transaction") {
            dataActivity.description = response.data.description
            dataActivity.name = response.data.name
          }

          if (params.foreign_table == "person") {

            if (params.action == 'personUpdated') {
              dataActivity.description = 'Os dados de ' + response.data.name + ' foram atualizados'
              dataActivity.id = 'Cod:  ' + response.data.person_code
            }

            if (params.action == 'personInserted') {
              dataActivity.description = response.data.name + '  foi Adicionado(a)'
              dataActivity.id = 'Cod:  ' + response.data.person_code
            }

          }

          // product_base
          if (params.foreign_table == "product_base") {

            if (params.action == 'storeProduct') {
              dataActivity.id = 'Código (SKU):' + response.data.base_sku_id
              dataActivity.description = 'O produto ' + response.data.description + '  foi Adicionado'
            }
            if (params.action == 'updateProduct') {
              dataActivity.id = 'Código (SKU):' + response.data.base_sku_id
              dataActivity.description = 'O produto ' + response.data.description + ' foi Atualizado'
            }
          }

          // account
          if (params.foreign_table == "account") {

            if (params.action == 'storeAccount') {

              if (response.data.type == 'c') {
                dataActivity.description = response.data.description + ' foi Adicionado'
              }
              if (response.data.type == 'b') {
                dataActivity.description = response.data.description + ' foi Adicionado'
              }
              if (response.data.type == 'd') {
                dataActivity.description = response.data.description + ' foi Adicionado'
              }
            }

            if (params.action == 'updateAccount') {
              if (response.data.type == 'c') {
                dataActivity.description = response.data.description + ' foi Atualizado'
              }
              if (response.data.type == 'b') {
                dataActivity.description = response.data.description + ' foi Atualizada'
              }
              if (response.data.type == 'd') {
                dataActivity.description = response.data.description + ' foi Atualizada'
              }
            }
          }

          // order
          if (params.foreign_table == "order") {

            if (response.data.unidentified_client == 1) {
              dataActivity.name = 'Cliente não Identificado'
            }
            if (response.data.unidentified_client == 0) {
              dataActivity.name = response.data.name
            }
            if (params.action == 'orderInsertedAsConfirmed') {
              dataActivity.description = 'Venda de N° ' + response.data.number + '  Confirmada'
            }
            if (params.action == 'orderCanceled') {
              dataActivity.description = 'Venda de N° ' + response.data.number + ' Cancelada'
            }
          }

          if (params.foreign_table == "user") {
            if (params.action == 'userUpdate') {
              dataActivity.description = 'Os dados do usuário foram atualizados'
              dataActivity.name = response.data.name
            }
            if (params.action == 'userStore') {
              dataActivity.description = response.data.name + '  Foi cadastrado como novo usuário '
            }
          }


          if (params.foreign_table == "company") {
            dataActivity.description = 'Sem Descrição'
          }

          if (params.foreign_table == "product_variant") {
            dataActivity.description = 'Sem Descrição'
          }

          if (params.foreign_table == "product_company") {
            dataActivity.description = 'Sem Descrição'
          }

          if (params.foreign_table == "stock_transaction") {
            dataActivity.description = 'Sem Descrição'
          }

          commit('setActivity', dataActivity)

        }).catch(error => { console.log(error) })

    }

  }

}
